import { useNavigate } from "react-router-dom";
import { sizesFor } from "../../data/catalog";
import useBrowseState from "../../hooks/useBrowseState";
import { shopPath } from "../../routes";

export default function SizeFilter() {
  const navigate = useNavigate();
  const { department, subcategory, size, sort } = useBrowseState();
  const sizes = sizesFor(department, subcategory);

  const go = (next) => navigate(shopPath({ department, subcategory, size: next, sort }));

  return (
    <div className="sizeShop" id="sizeShop" hidden={!sizes}>
      {sizes && (
        <>
          <div className="sizeShopTitle">Shop by Size</div>
          <div className="sizeRail">
            <button type="button" className={`sizeChip sizeClear ${size === "All" ? "active" : ""}`} onClick={() => go("All")}>
              All
            </button>
            {sizes.map((z) => (
              <button type="button" key={z} className={`sizeChip ${size === z ? "active" : ""}`} onClick={() => go(z)}>
                {department === "Apparel" && z === "2XL" ? "PLUS" : z}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
